import _ from 'lodash';
import React from 'react';

import { CheckableDropdown } from '../CheckableDropdown';

// import './CheckableDropdownGDS.css';

const SalleFiltre = ({ defaultSalles, selected, onSalleSelect }) => {
    const [salles, setSalles] = React.useState(defaultSalles);
    const [options, setOptions] = React.useState([]);

    const handleOptionSelect = React.useCallback((data) => {
        setOptions(data)

        if (onSalleSelect) {
            onSalleSelect(data);
        }
    }, [onSalleSelect]);

    const formatSalleToOption = React.useCallback((data) => ({
        key: "salle@" + data.id,
        value: data.identifiantSalle,
        text: data.name,
        selected: true // Tout sélectionné par défaut
    }), []);
    
    const formatTypeToOption = React.useCallback((data) => ({
        key: "type@" + data.id,
        value: data.id,
        text: data.name,
        group: true,
        selected: true // Tout sélectionné par défaut
    }), []);

    React.useEffect(() => {
        if (_.isEmpty(salles)) {
            setSalles(defaultSalles)
        }
    }, [defaultSalles, salles])

    React.useEffect(() => {
        const types = _.filter(salles, { groupOnly: true });

        const sallesParType = _.map(types, (type) => {
            const { id } = type;

            return {
                ...formatTypeToOption(type),
                items: _.map(
                    _.filter(salles, { parentId: id }),
                    (salle) => formatSalleToOption(salle)
                )
            };
        });

        setOptions(sallesParType)

        if (onSalleSelect) {
            onSalleSelect(sallesParType);
        }
    }, [formatSalleToOption, formatTypeToOption, onSalleSelect, salles]);

    // Quand la props selected change, on met à jour les options pour qu'elles correspondent
    React.useEffect(() => {
        const { affichageDefaut } = window;
        const {
            salles: sallesContext // Pour garder le context dans webdev
        } = affichageDefaut || {};

        setOptions(prevOptions => {
            const nextOpt = _.map(prevOptions, (option) => {
                const {
                    group,
                    items,
                    value: valueOption,
                } = option;
                
                if (group) {
                    let allSelectedInGroup = true;

                    let nextItems = _.map(items, ({ value, ...restItem }) => {
                        const isNowSelected = _.isNil(sallesContext)
                            ? _.includes(selected, value)
                            : _.includes(sallesContext, value);

                        if (!isNowSelected) {
                            allSelectedInGroup = false;
                        }

                        return ({
                            ...restItem,
                            value,
                            selected: isNowSelected
                        })
                    });

                    return {
                        ...option,
                        items: nextItems,
                        selected: allSelectedInGroup,
                    }
                }

                return {
                    ...option,
                    selected: _.isNil(sallesContext)
                        ? _.includes(selected, valueOption)
                        : _.includes(sallesContext, valueOption)
                }
            })

            if (!_.isNil(sallesContext) && onSalleSelect) {
                onSalleSelect(nextOpt);

                // La première fois qu'on passe ici, on reprend le context
                // donc après avoir repris, on remet à null
                window.affichageDefaut.salles = null;
            }

            return nextOpt;
        });
    }, [onSalleSelect, selected])
    
    return (
        <CheckableDropdown
            onOptionSelect={handleOptionSelect}
            options={options}
            placeholder='Sélectionner une salle'
            triggerStyle={{ width: 250 }}
        />
    );
};

export default SalleFiltre;